import {
  Box,
  Card,
  CardContent,
  Grid,
  Paper,
  Typography,
  styled,
} from "@mui/material";
import UserForm from "./UserForm";

import { ReactComponent as Logo1 } from "../../vendor/logo1.svg";
import { ReactComponent as Logo2 } from "../../vendor/logo2.svg";

import { spacing } from "@mui/system";
import { ToastContainer } from "react-toastify";
import OlogaConfirmDialog from "../../components/misc/OlogaConfirmDialog";
import { useState } from "react";

const Brand1 = styled(Logo1)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 30%;
  height: auto;
`;

const Brand2 = styled(Logo2)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 100%;
  height: auto;
  margin-bottom: 20px;
`;

const Container = styled(Box)`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  width: 80%;
  max-width: 700px;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
`;

const RightSection = styled(Box)`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers horizontally */
  justify-content: center; /* Centers vertically */
  text-align: center; /* Centers text under logos */
`;

function CandidateUser() {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Container>
      <ToastContainer position="top-right" />
      <FormPaper>
        <RightSection>
          <Box>
            <Brand1 />
            <Brand2 />
          </Box>
          <Typography variant="h6" gutterBottom>
            Preencha os campos que seguem, para efectuar o autoregisto.
          </Typography>
          <CardContent>
            <UserForm
              user={{
                id: null,
                firstName: "",
                lastName: "",
                username: "",
                email: "",
                password: "",
                confirmPassword: "",
                companyId: "",
                signup: true,
              }}
            />
          </CardContent>
        </RightSection>
      </FormPaper>
    </Container>
  );
}

export default CandidateUser;
